
import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const Advantages = () => {
  const faqs = [
    {
      question: "How quickly can you arrive for repairs?",
      answer: "We typically offer same-day or next-day service for most areas in the Greater Toronto Area."
    },
    {
      question: "Do you provide warranty on repairs?",
      answer: "Yes, we offer a 4-month warranty on both parts and labor for all our repair services."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept Cash, Debit Cards, and E-Transfers for your convenience."
    },
    {
      question: "What brands do you service?",
      answer: "We service major North American brands (Whirlpool, Maytag, KitchenAid, GE, Frigidaire), European brands (Bosch, Siemens, AEG, Electrolux, Miele), and Korean brands (LG, Samsung)."
    },
    {
      question: "What areas do you service?",
      answer: <span>We service the entire Greater Toronto Area. <Link to="/contact#service-area" className="text-blue-400 hover:text-blue-300">Click here</Link> to see our detailed service area map.</span>
    }
  ];

  const advantages = [
    {
      title: "Rapid Solution for Minimal Disruption",
      description: "Most repairs are completed within 2-24 hours, compared to waiting days or weeks for new appliance delivery and installation. Time is valuable - get back to your routine quickly.",
      forWealthy: true
    },
    {
      title: "Cost-Effective Solution",
      description: "Costs fractions of what a new appliance would.",
      forWealthy: false
    },
    {
      title: "Preserve High-End Features",
      description: "Keep your premium appliances with their custom features and finishes that match your carefully designed space.",
      forWealthy: true
    },
    {
      title: "Environmentally Conscious Choice",
      description: "Reduce landfill waste and support sustainable practices by extending the life of your existing appliances.",
      forWealthy: true
    },
    {
      title: "Familiar Operation",
      description: "Continue using the appliance you're already comfortable with, avoiding the learning curve of a new model.",
      forWealthy: false
    },
    {
      title: "Maintain Home Aesthetic",
      description: "Keep your existing appliance that perfectly matches your home's design and other appliances.",
      forWealthy: true
    }
  ];

  return (
    <div className="min-h-screen bg-[#222222] py-8 sm:py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8 text-center">
            Frequently Asked Questions
          </h2>
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-gray-700 rounded-lg overflow-hidden bg-[#2A2A2A]"
              >
                <AccordionTrigger className="px-6 py-4 text-white hover:text-primary hover:no-underline text-left font-bold">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="animate-slide-in-right duration-[1500ms]">
                  <div className="px-6 py-4 text-gray-300">
                    {faq.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8 text-center">
          Why Choose Appliance Repair?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="relative h-[300px] md:h-full">
            <img
              src="/lovable-uploads/0d893a2f-ae6b-434f-b73c-70eff4681fb8.png"
              alt="Professional appliance repair"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
          
          <div className="space-y-6">
            {advantages.map((advantage, index) => (
              <div 
                key={index}
                className={`p-6 rounded-lg ${
                  advantage.forWealthy 
                    ? 'bg-gradient-to-r from-[#333333] to-[#444444]' 
                    : 'bg-gradient-to-r from-[#2A2A2A] to-[#3A3A3A]'
                }`}
              >
                <h3 className="text-xl font-semibold text-white mb-2">
                  {advantage.title}
                </h3>
                <p className="text-gray-300">
                  {advantage.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advantages;
